import { RegisterPayload } from "src/library/types/types";

export const getHostName = () => {
  return process.env.REACT_APP_API_ENDPOINT;
};

export const registerUser = async (payload: RegisterPayload) => {
  const raw = JSON.stringify(payload);

  const requestOptions: RequestInit = {
    mode: "cors",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: raw,
    redirect: "follow",
  };

  return await fetch(`${getHostName()}/contact/register`, requestOptions);
};

export const verifyEmailAddress = async (reference: string) => {
  const requestOptions: RequestInit = {
    mode: "cors",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    redirect: "follow",
  };

  // TODO get endpoint when created
  return await fetch(
    `${getHostName()}/contact/subscriptions/${reference}`,
    requestOptions
  );
};

export const unsubscribeFromHackathonEmails = async (reference: string) => {
  const requestOptions: RequestInit = {
    mode: "cors",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    redirect: "follow",
  };

  // TODO check endpoint works
  return await fetch(`${getHostName()}/contact/unsubscribe/${reference}`, requestOptions);
};
